import { z } from "zod";

export const planFormSchema = z.object({
  name: z.string().min(1, { message: "Nome do plano é obrigatório" }),
  description: z.string().optional(),
  plan_features: z
    .array(z.string().min(1, { message: "Característica não pode estar vazia" }))
    .min(1, { message: "Pelo menos uma característica é obrigatória" })
    .max(10, { message: "Máximo de 10 características permitidas" }),
  markup: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? undefined : v),
      z.coerce.number().optional()
    )
    .optional(),
  markup_mode: z.enum(["percentage", "real_currency"]).optional(),
  products: z
    .array(
      z.object({
        id: z.string(),
        product_id: z.string().optional(),
        name: z.string().optional(),
        type: z.string().optional(),
        capital_value: z
          .preprocess(
            (v) => (v === "" || v === null || v === undefined ? undefined : v),
            z.coerce.number().optional()
          )
          .optional(),
        premium_value: z
          .preprocess(
            (v) => (v === "" || v === null || v === undefined ? undefined : v),
            z.coerce.number().optional()
          )
          .optional(),
        description: z.string().optional(),
        minimum_price: z
          .preprocess(
            (v) => (v === "" || v === null || v === undefined ? null : v),
            z.coerce.number().nullable().optional()
          )
          .nullable()
          .optional(),
        plan_name: z.string().nullable().optional(),
        insurance_policy_extra_price_id: z.string().nullable().optional(),
      })
    )
    .min(1, { message: "Pelo menos um produto é obrigatório" }),
  commission_distribution: z
    .array(
      z.object({
        agency: z
          .preprocess(
            (v) => (v === "" || v === null || v === undefined ? 0 : v),
            z.coerce.number()
          )
          .default(0),
        commission: z
          .preprocess(
            (v) => (v === "" || v === null || v === undefined ? 0 : v),
            z.coerce.number()
          )
          .default(0),
        position: z
          .preprocess(
            (v) => (v === "" || v === null || v === undefined ? 0 : v),
            z.coerce.number()
          )
          .default(0),
      })
    )
    .min(1, {
      message: "Pelo menos uma distribuição de comissão é obrigatória",
    }),
  commission_lifetime_other_installments: z
    .preprocess(
      (v) => (v === "" || v === null || v === undefined ? 0 : v),
      z.coerce.number()
    )
    .default(0),
});

export type TPlanFormSchema = z.infer<typeof planFormSchema>;

